import { MessageCircle, Phone } from 'lucide-react';
import { Button } from '../ui/button';

export const ServiceHero = ({ handleWhatsAppClick, handleCallClick }) => (
<section className="pt-32 pb-16 px-4">
        <div className="container mx-auto max-w-4xl text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-red-600">
            Retour Affectif Rapide Guadeloupe
          </h1>
          <p data-testid="service-practitioner-name" className="text-xl md:text-2xl text-yellow-400 mb-8">
            Récupérez l'être aimé en 3 à 7 jours avec le Grand Marabout Africain Maître Diamma
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button data-testid="service-hero-whatsapp-button" onClick={handleWhatsAppClick} size="lg" className="bg-gradient-to-r from-green-500 to-green-600">
              <MessageCircle className="w-5 h-5 mr-2" />
              WhatsApp Direct
            </Button>
            <Button data-testid="service-hero-call-button" onClick={handleCallClick} size="lg" variant="outline" className="border-white text-white">
              <Phone className="w-5 h-5 mr-2" />
              Appeler
            </Button>
          </div>
        </div>
      </section>
);
